import React from 'react';
import Hero from './Hero';
import NlpSection from './NlpSection';
import ProgramsPreview from './ProgramsPreview';
import Personas from './Personas';
import ManifestBanner from './ManifestBanner';
import Testimonials from './Testimonials';
import FAQ from './FAQ';
import Section from '../../components/ui/Section';
import Button from '../../components/ui/Button';

const Home = () => {
  return (
    <main>
      <Hero />
      <NlpSection />
      <ProgramsPreview />
      <Personas />
      <ManifestBanner />
      <Testimonials />
      <FAQ />
      {/* Lead Magnet / Newsletter Section */}
      <Section className="bg-wine-dark text-center border-t border-gold/20">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-serif text-cream mb-6">Kostenloser Manifestations-Guide</h2>
          <p className="text-cream/80 mb-10 text-lg font-light">
            Lade Dir Dein exklusives Workbook herunter und beginne noch heute, energetische Blockaden zu lösen.
            Dein erster Schritt in die Göttliche Fülle.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 justify-center" onSubmit={(e) => e.preventDefault()}>
            <input
              type="email"
              placeholder="Deine beste E-Mail Adresse"
              className="px-6 py-4 bg-dark/50 border border-white/20 text-cream placeholder:text-cream/40 focus:outline-none focus:border-gold w-full sm:w-96 rounded-sm transition-colors"
            />
            <Button variant="gold" type="submit">Gratis Workbook sichern</Button>
          </form>
          <p className="text-xs text-cream/40 mt-4">100% Sicher. Kein Spam. Abmeldung jederzeit möglich.</p>
        </div>
      </Section>
    </main>
  );
};

export default Home;